/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentCourseFinancialInfoViewModel } from "../types/IndividualPaymentCourseFinancialInfoViewModel.ts";

export const individualPaymentCourseFinancialInfoViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  totalValue: z.optional(z.number()),
  valueRegistration: z.optional(z.number()),
  discountPunctualPercentage: z.optional(z.number()),
}) as unknown as ToZod<IndividualPaymentCourseFinancialInfoViewModel>;
